import React from 'react';
import { Icon } from './Icon.js';
export const IconDarkMode = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5V19Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconDarkMode.js.map